import { z } from 'zod';

import { ToolCallsKwargsSchema } from '../Message.utils';
import { ToolCallsList } from './ToolCallsList';

export function MessageKwargsTools(props: {
  toolKwargs: z.infer<typeof ToolCallsKwargsSchema>;
  onEdit?: (value: z.infer<typeof ToolCallsKwargsSchema>) => void;
}) {
  const items = props.toolKwargs.tool_calls.map((tc) => ({
    name: tc.name,
    id: tc.id,
    args: tc.args as Record<string, unknown>,
  }));

  return (
    <ToolCallsList
      items={items}
      editable={!!props.onEdit}
      onChangeName={(index, name) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index
            ? {
                ...tc,
                name,
              }
            : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onChangeId={(index, id) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index
            ? {
                ...tc,
                id,
              }
            : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onChangeArgs={(index, value) => {
        if (!props.onEdit) return;
        const newToolCalls = props.toolKwargs.tool_calls.map((tc, i) =>
          i === index ? { ...tc, args: value as Record<string, unknown> } : tc
        );
        props.onEdit({ ...props.toolKwargs, tool_calls: newToolCalls });
      }}
      onDelete={(index) => {
        if (!props.onEdit) return;
        props.onEdit({
          ...props.toolKwargs,
          tool_calls: props.toolKwargs.tool_calls.filter(
            (_, idx) => idx !== index
          ),
        });
      }}
    />
  );
}
